import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { parseDateValue } from "../../classes/utils/DateUtils";
import { GET_HEIGHTS_BY_IDS } from "../../queries/heightQueries";

export function useHeightsData(heightIds) {
  const { data, loading, error, refetch } = useQuery(GET_HEIGHTS_BY_IDS, {
    variables: { ids: heightIds },
    skip: !heightIds?.length,
    fetchPolicy: "network-only",
  });

  const heights = useMemo(() => {
    return data?.heightsByIds || [];
  }, [data]);

  const heightsByDate = useMemo(() => {
    // Create a copy of the array before sorting (most recent first)
    return [...heights].sort(
      (a, b) =>
        (parseDateValue(b.date)?.getTime() ?? 0) -
        (parseDateValue(a.date)?.getTime() ?? 0)
    );
  }, [heights]);

  const latestHeight = useMemo(() => {
    return heightsByDate[0] || null;
  }, [heightsByDate]);

  const currentHeightValue = useMemo(() => {
    return latestHeight?.value || null;
  }, [latestHeight]);

  return {
    heights,
    heightsByDate,
    latestHeight,
    currentHeightValue,
    loading,
    error,
    refreshHeights: refetch,
  };
}
